import { AuditEntityType, CreateMediaChildrenDataDto, MediaBasicDataDto, MediaInfoDto, UpdateMediaBasicDto } from '@sr/dto';
import { mediaApi } from 'entities/media/api-slice';
import { MEDIA_BASE_URL } from 'shared/api/api';
import { invalidateEntityAudit } from 'entities/audit/utils';


const injectedApi = mediaApi.injectEndpoints({
  endpoints: (builder) => ({
    getMediaBasicData: builder.query<MediaBasicDataDto, number>({
      query: (id: number) => ({
        url: `${MEDIA_BASE_URL}/${id}`,
        method: 'GET'
      }),
    }),
    updateMediaBasicData: builder.mutation<MediaBasicDataDto, UpdateMediaBasicDto>({
      query: (data: UpdateMediaBasicDto) => ({
        url: MEDIA_BASE_URL,
        body: data,
        method: 'PATCH'
      }),
      async onQueryStarted(data, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          invalidateEntityAudit(dispatch, AuditEntityType.MEDIA, data.id);
        } catch (error) {
          console.error('Failed to invalidate media audit after basic data update', error);
        }
      },
    }),
    createMediaChild: builder.mutation<MediaInfoDto, CreateMediaChildrenDataDto>({
      query: (data: CreateMediaChildrenDataDto) => ({
        url: `${MEDIA_BASE_URL}/media-child`,
        body: data,
        method: 'POST'
      }),
      async onQueryStarted(data, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          invalidateEntityAudit(dispatch, AuditEntityType.MEDIA, data.media?.id);
        } catch (error) {
          console.error('Failed to invalidate media audit after creating child media', error);
        }
      },
    })
  }),
  overrideExisting: true
});

export const mediaBasicDataApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['media-basic-data'],
  endpoints: {
    getMediaBasicData: {
      providesTags: ['media-basic-data']
    },
    updateMediaBasicData: {
      invalidatesTags: ['media-basic-data']
    },
    createMediaChild: {
      invalidatesTags: ['media-basic-data']
    }
  }
})
